import { render, staticRenderFns } from "./CProjectDetailPublicPage.vue?vue&type=template&id=4052393e&"
import script from "./CProjectDetailPublicPage.vue?vue&type=script&lang=ts&"
export * from "./CProjectDetailPublicPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports